import { CalendarClock } from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { PERMISSIONS, usePermission } from '@/lib/permissions'
import { cn } from '@/lib/utils'

/**
 * The Shift Dashboard from anywhere (z8nrz7fbcj): an icon in the header line,
 * beside Audit. Rendered by the TopBar and by the /dashboard header, which
 * hides the TopBar — the same two places as AuditCenterLink.
 *
 * Shown only to someone who may open the page; the route and the endpoints
 * enforce the same keys. The name lives in `title` and `aria-label`, since the
 * icon has no text of its own.
 */
export function ShiftDashboardLink() {
  const { canAny } = usePermission()
  if (!canAny([PERMISSIONS.shiftDashboardView, PERMISSIONS.shiftDashboardManage])) return null
  return (
    <NavLink
      to='/shift-dashboard'
      title='Shift Dashboard'
      aria-label='Shift Dashboard'
      className={({ isActive }) =>
        cn(
          'flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
          isActive && 'bg-muted text-primary',
        )
      }
    >
      <CalendarClock className='h-4 w-4' />
    </NavLink>
  )
}
